import { queryClient } from "@/base/libs/react-query";
import { useProjectController } from "@/controller/project-controller";
import { projectApi } from "@/service/client";
import { AiModel } from "@/shared/model/enum/ai-model_type";
import { DataSource } from "@/shared/model/enum/data-source";
import { Project } from "@/shared/model/project.model";
import { Suggestion } from "@/shared/model/suggestion.model";
import { useQuery } from "@tanstack/react-query";

export const useProjectIdController = () => {
  const projectController = useProjectController();

  const { selectedProject } = projectController;

  const { data: suggestionList } = useQuery<Suggestion[]>({
    queryKey: ["suggestion", selectedProject?._id],
    enabled: !!selectedProject?._id,
    queryFn: () => projectApi.listSuggestions(selectedProject?._id!),
  });

  const updateProject = async ({
    name,
    sitemap_list,
  }: {
    name: string;
    sitemap_list: string;
  }) => {
    const project: Partial<Project> = {
      name,
      sitemap_list: sitemap_list.split(",").map((sitemap) => sitemap.trim()),
    };

    const projectUpdated = await projectApi.update(
      selectedProject?._id!,
      project
    );

    queryClient.invalidateQueries({
      queryKey: ["project", selectedProject?._id],
    });

    projectController.onSelectProject(projectUpdated);

    return projectUpdated;
  };

  const generateSuggestion = async (
    url: string,
    dataSource: DataSource,
    aiModel: AiModel
  ): Promise<Suggestion> => {
    const suggestion = await projectApi.generateSuggestion(
      selectedProject?._id!,
      url,
      dataSource.code,
      aiModel.code
    );
    queryClient.invalidateQueries({
      queryKey: ["suggestion", selectedProject?._id],
    });
    return suggestion;
  };

  const deleteProject = async () => {
    await projectApi.delete(selectedProject?._id!);
    queryClient.invalidateQueries({ queryKey: ["projects"] });
    queryClient.removeQueries({ queryKey: ["project", selectedProject?._id] });
    queryClient.removeQueries({
      queryKey: ["suggestion", selectedProject?._id],
    });
  };

  return {
    selectedProject,
    suggestionList,
    updateProject,
    generateSuggestion,
    deleteProject,
  };
};
